import { styled, Table } from '@/theme/index';
import { JsonGedcomData } from '../../Topola/data';

export interface FamilyInsightsProps {
  permalink: string;
  ancestryTreeData?: JsonGedcomData;
}

export interface FamilyTreeInsightsData {
  populated_member_count: number;
  unique_first_name_counts: [string, number][];
  average_living_members_age: number;
  unique_location_counts: number;
  location_counts: {
    [key: string]: {
      [key: string]: number;
    };
  };
  unique_surname_counts: [string, number][];
  oldest_living_member: {
    member_id: number;
    age: number;
  };
  oldest_ancestor: {
    member_id: number;
    date: string;
  };
  first_documented_location: {
    member_id: number;
    city: string;
    state: string;
    date: string;
  };
}

export const StyledTable = styled(Table)({
  '.MuiTableCell-root': {
    padding: '16px 8px',
    fontSize: '16px',
    fontWeight: '700',
  },
  '.MuiTableRow-root:not(:last-child)': {
    borderWidth: '0px 0px thin',
    borderStyle: 'solid',
    borderColor: 'rgb(226, 226, 226)',
  },
  'tr.MuiTableRow-root td:nth-child(2)': {
    fontWeight: 'normal',
  },
});

export const StyledTableEvenChildsWithBg = styled(Table)(({ theme }) => ({
  '.MuiTableCell-root': {
    padding: '16px 8px',
    fontSize: '16px',
    fontWeight: '700',
  },
  '.MuiTableRow-root:nth-child(even)': {
    backgroundColor: theme.palette.background.paper,
  },
  'tr.MuiTableRow-root td:nth-child(1), tr.MuiTableRow-root td:nth-child(3) ': {
    fontWeight: 'normal',
  },
}));

export const StyledImg = styled('img')({
  margin: 'auto',
  display: 'block',
});
